<template>
  <div class="homePage">
    <div class="fiex" :style="{ top: menuTop + 'px' }">
      <Navigation :active="4"></Navigation>
    </div>
    <div class="right">
      <div class="card-boxs">
        <div class="card-box">
          <div class="number">{{ userInfo.balance }}</div>
          <div class="text-box">
            <span>{{ $t("module.goldHistory.title1") }}</span>
            <img src="@/assets/image/module/lament.png" />
          </div>
        </div>
        <div class="card-box">
          <div class="number">{{ userInfo.frozenPonints }}</div>
          <div class="text-box">
            <span>{{ $t("module.goldHistory.title2") }}</span>
            <img src="@/assets/image/module/question.png" />
          </div>
        </div>
        <div class="card-box">
          <div class="number">{{ income }}</div>
          <div class="text-box">
            <span>{{ $t("module.goldHistory.title3") }}</span>
          </div>
        </div>
        <div class="card-box">
          <div class="number">{{ expense }}</div>
          <div class="text-box">
            <span>{{ $t("module.goldHistory.title4") }}</span>
          </div>
        </div>
      </div>
      <div class="screen-box">
        <div class="input-box-fa">
          <div class="input-box">
            <div class="title">{{ $t("module.goldHistory.title16") }}</div>
            <el-date-picker
              v-model="year"
              type="year"
              value-format="yyyy"
              :placeholder="$t('module.goldHistory.title17')"
            >
            </el-date-picker>
          </div>
          <div class="input-box">
            <div class="title">{{ $t("module.goldHistory.title18") }}</div>
            <el-select v-model="cateId" clearable>
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div class="input-box">
            <div class="title">{{ $t("module.goldHistory.title19") }}</div>
            <el-select
              v-model="typeId"
              :placeholder="$t('module.goldHistory.title10')"
              clearable
            >
              <el-option
                v-for="item in PointTypes"
                :key="item.ID"
                :label="item.TypeName"
                :value="item.ID"
              >
              </el-option>
            </el-select>
          </div>

          <button class="screen-btn" @click="getPoints(1)">
            <i class="el-icon-refresh-right refresh" v-if="flagpc"></i>
            {{ $t("module.goldHistory.title11") }}
          </button>
        </div>
      </div>
      <div class="screen-box2">
        <div class="left">{{ $t("module.goldHistory.title15") }}</div>
        <el-select
          v-model="cateId2"
          @change="getPoints2(1)"
          :placeholder="$t('module.goldHistory.title18')"
          clearable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="list-box" ref="scrollContainer" @scroll="handleScroll">
        <div class="list-item" v-for="(item, index) in tableData2" :key="index">
          <div class="line-box">
            <div class="title">{{ item.description }}</div>
            <div class="color1">{{ item.dateline | dateFrom }}</div>
          </div>
          <div class="content">
            {{ item.typeId === 1 ? "+" : "-" }}{{ item.quantity }}
          </div>
        </div>
        <div class="flag" v-if="!flag && tableData2.length !== 0">
          {{ $t("module.goldHistory.title20") }}
        </div>
        <div class="flag" v-if="flag && tableData2.length !== 0">
          {{ $t("module.goldHistory.title21") }}
        </div>

        <el-empty
          v-if="tableData2.length === 0"
          :description="$t('module.goldHistory.title22')"
        ></el-empty>
      </div>
      <div class="table-box">
        <el-table :data="tableData" height="880" border style="width: 100%">
          <el-table-column prop="name" :label="$t('module.goldHistory.title23')" width="150">
            <template slot-scope="scope">
              {{ scope.row.dateline | dateFrom }}
            </template>
          </el-table-column>
          <el-table-column prop="quantity" :label="$t('module.goldHistory.title24')" width="120">
          </el-table-column>
          <el-table-column
            prop="description"
            :label="$t('module.goldHistory.title25')"
            :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column prop="typeId" :label="$t('module.goldHistory.title18')" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.typeId == 1">{{ $t("module.goldHistory.title26") }}</span>
              <span v-if="scope.row.typeId == 2">{{ $t("module.goldHistory.title27") }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="typeId" :label="$t('module.goldHistory.title19')" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.categoryDesc">
                {{ scope.row.categoryDesc }}</span
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('module.goldHistory.title28')" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.statusDesc }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="getPoints(1)"
            @current-change="getPoints"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import {
  getPointSummary,
  getPoints,
  getPointTypeAll,
  getAccount,
} from "@/api/user";
export default {
  filters: {
    dateFrom(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      userInfo: {},
      value: null,
      value2: null,
      menuTop: 86,
      options: [
        {
          value: 1,
          label: this.$t("module.goldHistory.title26"),
        },
        {
          value: 2,
          label: this.$t("module.goldHistory.title27"),
        },
      ],

      income: 0,
      expense: 0,

      tableData: [],
      PointTypes: [],
      page: 1,
      size: 10,
      total: 0,
      cateId: null,
      typeId: null,
      flag: false,
      year: null,
      page2: 1,
      size2: 10,
      tableData2: [],
      cateId2: null,
      flagpc: false,
    };
  },
  components: { Navigation },
  methods: {
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },

    async getPointSummary() {
      await getPointSummary().then((res) => {
        if (res.code === 200) {
          this.income = res.data.income;
          this.expense = res.data.expense;
        }
      });
    },

    async getPoints(type) {
      if (this.flagpc) {
        return;
      }
      this.flagpc = true;
      if (type) {
        this.page = type;
      }
      await getPoints({
        page: this.page,
        size: this.size,
        cateId: this.cateId,
        typeId: this.typeId,
        year: this.year,
      })
        .then((res) => {
          this.flagpc = false;
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.dataCount;
          }
        })
        .catch(() => {
          this.flagpc = false;
        });
    },

    async getPoints2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      await getPoints({
        page: this.page2,
        size: this.size2,
        cateId: this.cateId2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },

    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.getPoints2();
      }
    },
  },
  async created() {
    this.year = new Date().getFullYear().toString();

    window.addEventListener("scroll", this.listenScroll);

    await this.getPointSummary();
    await this.getPoints();
    await this.getPoints2();

    await getPointTypeAll().then((res) => {
      if (res.code === 200) {
        this.PointTypes = res.data;
      }
    });

    await getAccount().then((res) => {
      if (res.code === 200) {
        this.userInfo = res.data;
        this.$store.commit("changeUserInfo", this.userInfo);
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    });
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
  }
}

//卡片
.card-boxs {
  display: flex;
  padding: 24px 32px;
  background-color: #fff;
  border-radius: 4px;
  .card-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 70px;
    .number {
      font-size: 22px;
      color: #232323;
      font-weight: bolder;
      margin-right: 6px;
    }
    .text-box {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-size: 14px;
      margin-top: 6px;
      text-align: center;
      img {
        width: 14px;
        height: 14px;
        margin-left: 8px;
      }
    }
  }
}

//表格
.table-box {
  margin-top: 16px;
  height: 960px;
  margin-bottom: 24px;
  background-color: #fff;
  .golds {
    color: #2fc600;
  }
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 25px;
  }
}
.participationStatus {
  color: #474f66;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    width: 7px;
    height: 7px;
    border-radius: 3.5px;
    margin-right: 10px;
  }
}
.Auditing {
  color: #8948ff;
}
//筛选
.screen-box {
  display: flex;
  padding: 20px 0 0 25px;
  background-color: #fff;
  margin-top: 16px;
  flex-wrap: wrap;
  justify-content: space-between;
  .input-box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-right: 25px;
    .title {
      color: #333333;
      font-size: 14px;
      font-weight: bolder;
      margin-right: 15px;
    }
    .el-select {
      width: 100px;
    }
    .el-date-editor {
      width: 120px;
    }
  }
  .input-box-fa {
    display: flex;
  }
  .screen-btn {
    cursor: pointer;
    margin-right: 25px;
    margin-bottom: 20px;
    border: none;
    color: #fff;
    padding: 0;
    width: 76px;
    height: 32px;
    background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
    box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
    border-radius: 16px 16px 16px 16px;
  }
}
// 筛选移动端
.screen-box2 {
  display: none;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .left {
    font-size: 16px;
    color: #232323;
  }
  .el-select {
    width: 100px;
  }
}

//列表移动端
.list-box {
  display: none;
  max-height: 500px;
  overflow: auto;
  margin-top: 15px;
  margin-bottom: 25px;
  .list-item {
    width: 100%;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 10px;
    padding: 17px 0 17px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .line-box {
      padding: 0 15px 0 15px;
      display: flex;
      flex-direction: column;
      font-size: 14px;
      color: #232323;
      margin-bottom: 12px;
      .title {
        font-size: 14px;
        color: #232323;
      }
      .color1 {
        font-size: 14px;
        color: #666666;
        margin-top: 6px;
      }
    }
    .content {
      margin-right: 15px;
      margin-left: 10px;
      color: #232323;
      font-size: 16px;
      font-weight: bolder;
      flex-shrink: 0;
    }
  }
  .flag {
    text-align: center;
    color: #999;
    font-size: 14px;
  }
}
</style>
<style scoped>
.table-box >>> .el-table__header .el-table__cell {
  background-color: #fafbfc;
  color: #474f66;
  font-size: 14px;
  font-weight: bolder;
  text-align: center;
}
.table-box >>> .el-table__body .el-table__cell {
  text-align: center;
  color: #474f66;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .card-boxs {
        .card-box {
          margin-right: 50px;
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      //筛选
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    .card-boxs {
      display: none;
    }
    .screen-box {
      display: none;
    }
    .table-box {
      display: none;
    }
    //筛选移动端
    .screen-box2 {
      display: flex;
    }
    .list-box {
      display: block;
    }
  }
}
</style>
<style scoped>
.refresh {
  -webkit-animation: rotate 1s linear infinite;
  -moz-animation: rotate 1s linear infinite;
  -o-animation: rotate 1s linear infinite;
  animation: rotate 1s linear infinite;
}
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>